interface AimeLogoProps {
  size?: number
  className?: string
}

export function AimeLogo({ size = 32, className }: AimeLogoProps) {
  // Two SVG variants live in /public — light theme uses deep-green ink,
  // dark theme uses the white version. We render both and toggle visibility
  // via the `dark` class on the root, so theme switching is instant.
  const baseStyle = { width: size, height: size }
  return (
    <span
      className={`inline-block ${className ?? ''}`}
      style={baseStyle}
      aria-label="Aime"
      role="img"
    >
      <img
        src="/aime-logo.svg"
        alt=""
        width={size}
        height={size}
        className="block size-full dark:hidden"
        draggable={false}
      />
      <img
        src="/aime-logo-white.svg"
        alt=""
        width={size}
        height={size}
        className="hidden size-full dark:block"
        draggable={false}
      />
    </span>
  )
}

interface AimeWordmarkProps {
  className?: string
}

export function AimeWordmark({ className }: AimeWordmarkProps) {
  return (
    <span
      className={`gradient-brand font-heading text-xl font-black tracking-tighter ${className ?? ''}`}
    >
      Aime
    </span>
  )
}
